import styled from 'styled-components';
import { TypographyStyles, colours } from '@storefront/lib-global';

export const ActualPrice = styled.span`
  ${TypographyStyles.Body.Medium.SemiBold}
  color: ${colours.BLACK};
`;

export const ThenPrice = styled.span`
  ${TypographyStyles.Body.Medium.RegularStrikethrough}
  color: ${colours.BLACK};
`;

export const WasPrice = styled.span`
  ${TypographyStyles.Body.Medium.RegularStrikethrough}
  color: ${colours.GREY};
`;
